export type ConversationNiche =
  | 'herbalism'
  | 'foraging'
  | 'natural_building'
  | 'nutrition'
  | 'yoga'
  | 'book_club'
  | 'eco_living'
  | 'permaculture'
  | 'pilates'
  | 'meditation'
  | 'nervous_system'
  | 'fasting';

export interface ConversationPost {
  id: string;
  user_id: string;
  niche: ConversationNiche;
  title: string;
  content: string;
  slug?: string;
  images?: string[];
  created_at: string;
  updated_at: string;
  user?: {
    username: string;
    avatar_url?: string;
    verified?: boolean;
  };
  conversation_comments?: { count: number }[];
}

export interface ConversationComment {
  id: string;
  post_id: string;
  parent_id: string | null;
  user_id: string;
  content: string;
  images?: string[];
  created_at: string;
  updated_at?: string;
  user?: {
    username: string;
    avatar_url?: string;
  };
  replies: ConversationComment[];
}

export interface NicheInfo {
  id: ConversationNiche;
  label: string;
  description: string;
  icon: string;
  color: string;
  banner?: string;
}

export const NICHES: NicheInfo[] = [
  {
    id: 'herbalism',
    label: 'Herbalism',
    description: 'Discuss herbs, remedies, and traditional plant medicine',
    icon: '🌿',
    color: 'bg-green-100 text-green-800 border-green-200'
  },
  {
    id: 'foraging',
    label: 'Foraging',
    description: 'Share tips on wild food, identification, and sustainable harvesting',
    icon: '🍄',
    color: 'bg-amber-100 text-amber-800 border-amber-200'
  },
  {
    id: 'natural_building',
    label: 'Natural Building Techniques',
    description: 'Explore eco-friendly construction methods and materials',
    icon: '🏡',
    color: 'bg-orange-100 text-orange-800 border-orange-200'
  },
  {
    id: 'nutrition',
    label: 'Nutrition',
    description: 'Conversations about healthy eating and nutritional wellness',
    icon: '🥗',
    color: 'bg-lime-100 text-lime-800 border-lime-200'
  },
  {
    id: 'yoga',
    label: 'Yoga',
    description: 'Share practices, poses, and yogic philosophy',
    icon: '🧘',
    color: 'bg-purple-100 text-purple-800 border-purple-200'
  },
  {
    id: 'book_club',
    label: 'Book Club',
    description: 'Discuss books on wellness, spirituality, and mindful living',
    icon: '📚',
    color: 'bg-blue-100 text-blue-800 border-blue-200'
  },
  {
    id: 'eco_living',
    label: 'Eco Living',
    description: 'Tips for sustainable and environmentally conscious lifestyle',
    icon: '🌍',
    color: 'bg-teal-100 text-teal-800 border-teal-200'
  },
  {
    id: 'permaculture',
    label: 'Permaculture & Gardening',
    description: 'Growing food, designing gardens, and regenerative practices',
    icon: '🌱',
    color: 'bg-emerald-100 text-emerald-800 border-emerald-200'
  },
  {
    id: 'pilates',
    label: 'Pilates',
    description: 'Discuss techniques, exercises, and mind-body connection',
    icon: '💪',
    color: 'bg-rose-100 text-rose-800 border-rose-200'
  },
  {
    id: 'meditation',
    label: 'Meditation',
    description: 'Share meditation practices, techniques, and mindfulness',
    icon: '🧠',
    color: 'bg-indigo-100 text-indigo-800 border-indigo-200',
    banner: 'https://afvltpqnhmaxanirwnqz.supabase.co/storage/v1/object/public/community-images/59bed50f-5ccf-4265-87fa-7743af34d361/Meditation-conv.png'
  },
  {
    id: 'nervous_system',
    label: 'Nervous System Regulation',
    description: 'Discuss techniques for regulating the nervous system and trauma healing',
    icon: '🌿',
    color: 'bg-teal-100 text-teal-800 border-teal-200',
    banner: 'https://afvltpqnhmaxanirwnqz.supabase.co/storage/v1/object/public/listing-images/123c446f-e80c-409d-a3d3-e6fdc14949d4/FieldOfGrass.png'
  },
  {
    id: 'fasting',
    label: 'Fasting',
    description: 'Discuss intermittent fasting, water fasting, and dietary cleansing practices',
    icon: '🍃',
    color: 'bg-green-100 text-green-800 border-green-200',
    banner: 'https://afvltpqnhmaxanirwnqz.supabase.co/storage/v1/object/public/listing-images/123c446f-e80c-409d-a3d3-e6fdc14949d4/Long%20green%20grasses.jpg'
  }
];
